// removed by extract-text-webpack-plugin
module.exports = {"Gallery__container":"_2z7ZLqWg5qQWYMmqiJOzKU","Gallery__header":"_1B-H6Mm0A6XmI05r-dQvSo","Gallery__title":"_3XEgG1Tw1VD0vi1zSQTvV4"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Gallery/Gallery.scss
// module id = 2933
// module chunks = 0